'use strict'

modulePageSettings = angular.module('pagesSettings.controller', [])

modulePageSettings.controller "PagesSettingsCtrl", ["$scope", "$state", "$timeout", "Page", "Modal", "$rootScope", "editorDragPanel", ($scope, $state, $timeout, Page, Modal, $rootScope, editorDragPanel) ->

  # Pages

  $scope.currentPageName = $state.params.pageId
  $scope.createPage = Modal.createPage
  $scope.editPage = Modal.editPage

  # Pages tree options

  $scope.treeOptions =
    dropped: (e) ->
      _.each $rootScope.site.pages, (node) ->
        node.has_parent = false
        node.parent_id = null
        list = _.filter node.pages, {id: e.source.nodeScope.$modelValue.id}
        if list.length > 0
          list[0].parent_id = node.id
          list[0].has_parent = true
      Page.update(e.source.nodeScope.$modelValue).then ->
        Page.sort e.dest.nodesScope.$modelValue

  # State go to page

  $scope.goToPage = (page) ->
    return false if !page.path
    $state.go "site.page.editor", {pageId: page.path}

  # Removing page from scope

  removeFromList = (page) ->
    _.each $rootScope.site.pages, (aPage, index) ->
      if aPage and aPage.id is page.id
        $rootScope.site.pages.splice index, 1
      if aPage and aPage.pages
        _.each aPage.pages, (subpage, aIndex) ->
          if subpage and subpage.id is page.id
            $rootScope.site.pages[index].pages.splice aIndex, 1
    homePage = _.filter($rootScope.site.pages, {home: true})[0]
    if page.path is $state.params.pageId
      $state.go "site.page.editor", {siteId: $state.params.siteId, pageId: homePage.path}

  # Request delete page with alert

  $scope.deletePage = (page) ->
    $rootScope.alertDialog
      title: "Удаление страницы"
      text: "Вы действительно хотите удалить страницу?"
      accept_text: "Да"
      cancel_text: "Отмена"
      accept: ->
        $scope.deletingPage = true
        Page.delete(page).then ->
          $scope.deletingPage = false
          removeFromList page
        , ->
          $scope.deletingPage = false
]



// WEBPACK FOOTER //
// ./src/app/editor/pageSettings.controller.coffee